module.exports = __webpack_public_path__ + "static/media/questioner-talk.a599fe47.gif";